// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"89d903d2","4426":"af8c69df","4520":"95226c40","7151":"bc4ccc58","8401":"af8c69df","8876":"80d98603"}[chunkId] + ".chunk.css";
};